import * as React from "react";
const SvgFiRrDog = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dog_svg__a)">
      <path
        fill="#062147"
        d="M21.618 5a.8.8 0 0 1-.724-.447A2.79 2.79 0 0 0 18.382 3H17V.77c0-.525-.522-.904-1.015-.726A3 3 0 0 0 14 2.868V4.5l-.964 2.839c-.143.395-.521.66-.94.66l-5.098.004c-1.091 0-2.1.353-2.923.948C3.475 8.674 2 7.81 2 6a1 1 0 0 0-2 0c0 2.472 1.596 3.834 2.688 4.476a4.97 4.97 0 0 0-.687 2.528l.002 8.002a3 3 0 0 0 2.999 2.997 3.003 3.003 0 0 0 2.999-2.998v-2.002l5-.003v2a3.004 3.004 0 0 0 3.005 3 3 3 0 0 0 2.999-3v-2.765c0-.418.044-.837.131-1.247l1.062-4.994a4.004 4.004 0 0 0 3.804-3.995v-.5c0-1.834-1.424-2.5-2.382-2.5zM22 8c0 1.103-.897 2-2 2-.827 0-1.551.586-1.721 1.393l-1.101 5.18a8 8 0 0 0-.175 1.662v2.767a1.001 1.001 0 0 1-2.004 0V18a1 1 0 0 0-1-1l-7 .003a1 1 0 0 0-1 1v3.002a1 1 0 0 1-1.998 0l-.002-8.002c0-1.654 1.345-3 2.998-3.001L12.095 10a3.01 3.01 0 0 0 2.82-1.982L16.004 5h2.375c.309 0 .586.17.724.447A2.79 2.79 0 0 0 21.615 7c.382 0 .382.363.382.5V8z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dog_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDog;
